import  { FC, useMemo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {  FlexBox, useToasts } from '@brg/ui';
import styled from 'styled-components';
import { BTag } from 'core/components';
import { API, Endpoints } from '@brg/api';

interface ImportGroupsModalProps {
    groups: string[];
    teamId: string;
    onClose: () => void;
    onUpdate: (val: any) => void;
    onGroupsChange?: (selectedGroups: string[]) => void;
    onTeamDataRefresh?: () => void;
    onGroupsRefresh?: () => void;
}

const ModalContent = styled.div`
    padding: 24px;
    width: 100%;
`;

const ModalTitle = styled.h2`
    margin: 0 0 20px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
`;

const GroupsList = styled(FlexBox)`
    max-height: 400px;
    overflow-y: auto;
    > div:first-child {
        margin-top: 8px;
        margin-left: 16px;
    }
`;


const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
    font-style: italic;
`;

const CloseButton = styled.button`
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    min-width: 180px;
    
    &:hover:not(:disabled) {
        background-color: #0056b3;
    }
    
    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
        opacity: 0.6;
    }
`;
const SelectedGroupsSection = styled.div`
    margin-bottom: 20px;
    padding: 16px;
    background-color: #e3f2fd;
    border-radius: 8px;
    border: 1px solid #2196f3;
`;

const SelectedGroupsLabel = styled.div`
    font-weight: 600;
    color: #1976d2;
    margin-bottom: 8px;
    font-size: 14px;
`;

const SelectedGroupsText = styled.div`
    color: #1565c0;
    font-size: 14px;
    line-height: 1.4;
`;


export const ImportGroupsModal: FC<ImportGroupsModalProps> = ({ groups, teamId, onClose, onGroupsChange, onUpdate, onTeamDataRefresh, onGroupsRefresh }) => {
    const { t } = useTranslation();
    const toasts = useToasts();
    const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

    const handleImport = useCallback(() => {
        if (selectedGroups.length === 0) {
            toasts.error(t('teams.adminPage.import.modal.noGroupsSelected'));
            return;
        }

        API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/ImportTTData')
                .post()
                .body({
                    teamId,
                    groupNames: selectedGroups
                })
                .release();
        toasts.info(t('teams.adminPage.import.modal.importSuccess'));
        onUpdate(Date.now())
        setTimeout(() => {
             if (onTeamDataRefresh) {
                onTeamDataRefresh();
            }
            if (onGroupsRefresh) {
                onGroupsRefresh();
            }
            onClose();
        }, 1000)
        
    }, [selectedGroups, teamId, onClose, t]);

    const handleGroupToggle = (group: string) => {
        const newSelectedGroups = selectedGroups.includes(group) 
            ? selectedGroups.filter(g => g !== group)
            : [...selectedGroups, group];
        
        setSelectedGroups(newSelectedGroups);
        
        if (onGroupsChange) {
            onGroupsChange(newSelectedGroups);
        }
    };

    const selectedGroupsString = useMemo(() => {
        return selectedGroups.join(', ');
    }, [selectedGroups]);

    return (
        <ModalContent>
            <ModalTitle>
                {t('teams.adminPage.import.modal.title') || 'Группы'}
            </ModalTitle>
            
            {selectedGroups.length > 0 && (
                <SelectedGroupsSection>
                    <SelectedGroupsLabel>
                        {t('teams.adminPage.import.modal.selectedGroups') || 'Выбранные группы:'}
                    </SelectedGroupsLabel>
                    <SelectedGroupsText>
                        {selectedGroupsString}
                    </SelectedGroupsText>
                </SelectedGroupsSection>
            )}
            
            <GroupsList wrap='wrap' gx={16} gy={8}>
                {groups && groups.length > 0 ? (
                    groups.map((group: string) => (

                            <BTag
                                selected={selectedGroups.includes(group)}
                                onClick={() => handleGroupToggle(group)}
                                key={group}
                                
                            >
                                {group}
                            </BTag>

                    ))
                ) : (
                    <EmptyState>
                        {t('teams.adminPage.import.modal.noGroups')}
                    </EmptyState>
                )}
            </GroupsList>

            <FlexBox justify="flex-start">
                <CloseButton onClick={handleImport}>
                {t('teams.adminPage.import.modal.import')}
            </CloseButton>
            </FlexBox>
        </ModalContent>
    );
};
import  { FC, useMemo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {  FlexBox, useToasts } from '@brg/ui';
import styled from 'styled-components';
import { BTag } from 'core/components';
import { API, Endpoints } from '@brg/api';

interface ImportGroupsModalProps {
    groups: string[];
    teamId: string;
    onClose: () => void;
    onUpdate: (val: any) => void;
    onGroupsChange?: (selectedGroups: string[]) => void;
    onTeamDataRefresh?: () => void;
    onGroupsRefresh?: () => void;
}

const ModalContent = styled.div`
    padding: 24px;
    width: 100%;
`;

const ModalTitle = styled.h2`
    margin: 0 0 20px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
`;

const GroupsList = styled(FlexBox)`
    max-height: 400px;
    overflow-y: auto;
    > div:first-child {
        margin-top: 8px;
        margin-left: 16px;
    }
`;


const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
    font-style: italic;
`;

const CloseButton = styled.button`
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    min-width: 180px;
    
    &:hover:not(:disabled) {
        background-color: #0056b3;
    }
    
    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
        opacity: 0.6;
    }
`;
const SelectedGroupsSection = styled.div`
    margin-bottom: 20px;
    padding: 16px;
    background-color: #e3f2fd;
    border-radius: 8px;
    border: 1px solid #2196f3;
`;

const SelectedGroupsLabel = styled.div`
    font-weight: 600;
    color: #1976d2;
    margin-bottom: 8px;
    font-size: 14px;
`;

const SelectedGroupsText = styled.div`
    color: #1565c0;
    font-size: 14px;
    line-height: 1.4;
`;


export const ImportGroupsModal: FC<ImportGroupsModalProps> = ({ groups, teamId, onClose, onGroupsChange, onUpdate, onTeamDataRefresh, onGroupsRefresh }) => {
    const { t } = useTranslation();
    const toasts = useToasts();
    const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

    const handleImport = useCallback(() => {
        if (selectedGroups.length === 0) {
            toasts.error(t('teams.adminPage.import.modal.noGroupsSelected'));
            return;
        }

        API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/ImportTTData')
                .post()
                .body({
                    teamId,
                    groupNames: selectedGroups
                })
                .release();
        toasts.info(t('teams.adminPage.import.modal.importSuccess'));
        onUpdate(Date.now())
        setTimeout(() => {
             if (onTeamDataRefresh) {
                onTeamDataRefresh();
            }
            if (onGroupsRefresh) {
                onGroupsRefresh();
            }
            onClose();
        }, 1000)
        
    }, [selectedGroups, teamId, onClose, t]);

    const handleGroupToggle = (group: string) => {
        const newSelectedGroups = selectedGroups.includes(group) 
            ? selectedGroups.filter(g => g !== group)
            : [...selectedGroups, group];
        
        setSelectedGroups(newSelectedGroups);
        
        if (onGroupsChange) {
            onGroupsChange(newSelectedGroups);
        }
    };

    const selectedGroupsString = useMemo(() => {
        return selectedGroups.join(', ');
    }, [selectedGroups]);

    return (
        <ModalContent>
            <ModalTitle>
                {t('teams.adminPage.import.modal.title') || 'Группы'}
            </ModalTitle>
            
            {selectedGroups.length > 0 && (
                <SelectedGroupsSection>
                    <SelectedGroupsLabel>
                        {t('teams.adminPage.import.modal.selectedGroups') || 'Выбранные группы:'}
                    </SelectedGroupsLabel>
                    <SelectedGroupsText>
                        {selectedGroupsString}
                    </SelectedGroupsText>
                </SelectedGroupsSection>
            )}
            
            <GroupsList wrap='wrap' gx={16} gy={8}>
                {groups && groups.length > 0 ? (
                    groups.map((group: string) => (

                            <BTag
                                selected={selectedGroups.includes(group)}
                                onClick={() => handleGroupToggle(group)}
                                key={group}
                                
                            >
                                {group}
                            </BTag>

                    ))
                ) : (
                    <EmptyState>
                        {t('teams.adminPage.import.modal.noGroups')}
                    </EmptyState>
                )}
            </GroupsList>

            <FlexBox justify="flex-start">
                <CloseButton onClick={handleImport}>
                {t('teams.adminPage.import.modal.import')}
            </CloseButton>
            </FlexBox>
        </ModalContent>
    );
};
